export const RegionList = [{
    "region_en": "Riyadh",
    "region_ar": "الرياض",
    icon: '',
    id: '1'
}, {
    "region_en": "Jeddah",
    "region_ar": "جدة",
    icon: '',
    id: '2'
}, {
    "region_en": "Dammam",
    "region_ar": "الدمام",
    icon: '',
    id: '3'
}];